/**
 * Middle School Complete Vocabulary - Part H-M (H-M部分词汇)
 * 补充词汇约250个
 */

import { VocabularyWord } from './vocabulary';

export const vocabularyHM: VocabularyWord[] = [
  // H 部分词汇
  {
    id: 'habit', word: 'habit', phoneticUS: '/ˈhæbɪt/', phoneticUK: '/ˈhæbɪt/',
    meaning: '习惯', example: 'Good habit.', exampleTranslation: '好习惯。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '💪'
  },
  {
    id: 'hair', word: 'hair', phoneticUS: '/her/', phoneticUK: '/heə/',
    meaning: '头发', example: 'Long hair.', exampleTranslation: '长发。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '💇'
  },
  {
    id: 'half', word: 'half', phoneticUS: '/hæf/', phoneticUK: '/hɑf/',
    meaning: '一半', example: 'Half an hour.', exampleTranslation: '半小时。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '½'
  },
  {
    id: 'hall', word: 'hall', phoneticUS: '/hɑl/', phoneticUK: '/hɔl/',
    meaning: '大厅', example: 'The dining hall.', exampleTranslation: '餐厅。',
    category: 'places', difficulty: 'medium', grade: '8', level: 'middle', image: '🏛️'
  },
  {
    id: 'hand', word: 'hand', phoneticUS: '/hænd/', phoneticUK: '/hænd/',
    meaning: '手', example: 'Wash your hands.', exampleTranslation: '洗手。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '✋'
  },
  {
    id: 'handsome', word: 'handsome', phoneticUS: '/ˈhænsəm/', phoneticUK: '/ˈhænsəm/',
    meaning: '英俊的', example: 'He is handsome.', exampleTranslation: '他很英俊。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '😎'
  },
  {
    id: 'hang', word: 'hang', phoneticUS: '/hæŋ/', phoneticUK: '/hæŋ/',
    meaning: '悬挂', example: 'Hang the picture.', exampleTranslation: '挂画。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🖼️'
  },
  {
    id: 'happen', word: 'happen', phoneticUS: '/ˈhæpən/', phoneticUK: '/ˈhæpən/',
    meaning: '发生', example: 'What happened?', exampleTranslation: '发生了什么？',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'happiness', word: 'happiness', phoneticUS: '/ˈhæpinəs/', phoneticUK: '/ˈhæpinəs/',
    meaning: '幸福', example: 'Find happiness.', exampleTranslation: '寻找幸福。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'happy', word: 'happy', phoneticUS: '/ˈhæpi/', phoneticUK: '/ˈhæpi/',
    meaning: '快乐的', example: 'I am happy.', exampleTranslation: '我很快乐。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😊'
  },
  {
    id: 'hard', word: 'hard', phoneticUS: '/hɑrd/', phoneticUK: '/hɑd/',
    meaning: '困难的；硬的', example: 'Study hard.', exampleTranslation: '努力学习。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'hardly', word: 'hardly', phoneticUS: '/ˈhɑrdli/', phoneticUK: '/ˈhɑdli/',
    meaning: '几乎不', example: 'I hardly ever go.', exampleTranslation: '我几乎不去。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'harm', word: 'harm', phoneticUS: '/hɑrm/', phoneticUK: '/hɑm/',
    meaning: '伤害', example: 'Do no harm.', exampleTranslation: '不要伤害。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🚫'
  },
  {
    id: 'harmful', word: 'harmful', phoneticUS: '/ˈhɑrmfəl/', phoneticUK: '/ˈhɑmfəl/',
    meaning: '有害的', example: 'Smoking is harmful.', exampleTranslation: '吸烟有害。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '⚠️'
  },
  {
    id: 'harvest', word: 'harvest', phoneticUS: '/ˈhɑrvɪst/', phoneticUK: '/ˈhɑvɪst/',
    meaning: '收获', example: 'Harvest time.', exampleTranslation: '收获季节。',
    category: 'nature', difficulty: 'medium', grade: '9', level: 'middle', image: '🌾'
  },
  {
    id: 'hat', word: 'hat', phoneticUS: '/hæt/', phoneticUK: '/hæt/',
    meaning: '帽子', example: 'Wear a hat.', exampleTranslation: '戴帽子。',
    category: 'clothes', difficulty: 'easy', grade: '7', level: 'middle', image: '🎩'
  },
  {
    id: 'hate', word: 'hate', phoneticUS: '/heɪt/', phoneticUK: '/heɪt/',
    meaning: '讨厌', example: 'I hate rain.', exampleTranslation: '我讨厌下雨。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '👎'
  },
  {
    id: 'have', word: 'have', phoneticUS: '/hæv/', phoneticUK: '/hæv/',
    meaning: '有', example: 'I have a book.', exampleTranslation: '我有一本书。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'he', word: 'he', phoneticUS: '/hi/', phoneticUK: '/hi/',
    meaning: '他', example: 'He is a student.', exampleTranslation: '他是学生。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👦'
  },
  {
    id: 'head', word: 'head', phoneticUS: '/hed/', phoneticUK: '/hed/',
    meaning: '头', example: 'Use your head.', exampleTranslation: '动动脑筋。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'headache', word: 'headache', phoneticUS: '/ˈhedeɪk/', phoneticUK: '/ˈhedeɪk/',
    meaning: '头痛', example: 'I have a headache.', exampleTranslation: '我头痛。',
    category: 'body', difficulty: 'medium', grade: '8', level: 'middle', image: '🤕'
  },
  {
    id: 'health', word: 'health', phoneticUS: '/helθ/', phoneticUK: '/helθ/',
    meaning: '健康', example: 'Health is important.', exampleTranslation: '健康很重要。',
    category: 'body', difficulty: 'medium', grade: '8', level: 'middle', image: '💪'
  },
  {
    id: 'healthy', word: 'healthy', phoneticUS: '/ˈhelθi/', phoneticUK: '/ˈhelθi/',
    meaning: '健康的', example: 'Eat healthy food.', exampleTranslation: '吃健康食物。',
    category: 'body', difficulty: 'easy', grade: '8', level: 'middle', image: '🥗'
  },
  {
    id: 'hear', word: 'hear', phoneticUS: '/hɪr/', phoneticUK: '/hɪə/',
    meaning: '听见', example: 'I can hear you.', exampleTranslation: '我能听见你。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '👂'
  },
  {
    id: 'heart', word: 'heart', phoneticUS: '/hɑrt/', phoneticUK: '/hɑt/',
    meaning: '心', example: 'My heart beats.', exampleTranslation: '我的心跳。',
    category: 'body', difficulty: 'easy', grade: '8', level: 'middle', image: '❤️'
  },
  {
    id: 'heat', word: 'heat', phoneticUS: '/hiːt/', phoneticUK: '/hiːt/',
    meaning: '热', example: 'The heat is strong.', exampleTranslation: '热气很强。',
    category: 'weather', difficulty: 'medium', grade: '9', level: 'middle', image: '🌡️'
  },
  {
    id: 'heaven', word: 'heaven', phoneticUS: '/ˈhevən/', phoneticUK: '/ˈhevən/',
    meaning: '天堂', example: 'Go to heaven.', exampleTranslation: '去天堂。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '☁️'
  },
  {
    id: 'heavy', word: 'heavy', phoneticUS: '/ˈhevi/', phoneticUK: '/ˈhevi/',
    meaning: '重的', example: 'The box is heavy.', exampleTranslation: '箱子很重。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📦'
  },
  {
    id: 'height', word: 'height', phoneticUS: '/haɪt/', phoneticUK: '/haɪt/',
    meaning: '高度', example: 'What is your height?', exampleTranslation: '你多高？',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '📏'
  },
  {
    id: 'hello', word: 'hello', phoneticUS: '/həˈloʊ/', phoneticUK: '/həˈləʊ/',
    meaning: '你好', example: 'Hello, everyone!', exampleTranslation: '大家好！',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '👋'
  },
  {
    id: 'help', word: 'help', phoneticUS: '/help/', phoneticUK: '/help/',
    meaning: '帮助', example: 'Help me.', exampleTranslation: '帮帮我。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🤝'
  },
  {
    id: 'helpful', word: 'helpful', phoneticUS: '/ˈhelpfəl/', phoneticUK: '/ˈhelpfəl/',
    meaning: '有帮助的', example: 'This book is helpful.', exampleTranslation: '这本书有帮助。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '💡'
  },
  {
    id: 'hero', word: 'hero', phoneticUS: '/ˈhɪroʊ/', phoneticUK: '/ˈhɪərəʊ/',
    meaning: '英雄', example: 'He is a hero.', exampleTranslation: '他是英雄。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🦸'
  },
  {
    id: 'hide', word: 'hide', phoneticUS: '/haɪd/', phoneticUK: '/haɪd/',
    meaning: '躲藏', example: 'Hide and seek.', exampleTranslation: '捉迷藏。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🙈'
  },
  {
    id: 'high', word: 'high', phoneticUS: '/haɪ/', phoneticUK: '/haɪ/',
    meaning: '高的', example: 'The mountain is high.', exampleTranslation: '山很高。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏔️'
  },
  {
    id: 'hill', word: 'hill', phoneticUS: '/hɪl/', phoneticUK: '/hɪl/',
    meaning: '小山', example: 'Climb the hill.', exampleTranslation: '爬山。',
    category: 'nature', difficulty: 'easy', grade: '8', level: 'middle', image: '⛰️'
  },
  {
    id: 'him', word: 'him', phoneticUS: '/hɪm/', phoneticUK: '/hɪm/',
    meaning: '他（宾格）', example: 'Give it to him.', exampleTranslation: '给他。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👦'
  },
  {
    id: 'himself', word: 'himself', phoneticUS: '/hɪmˈself/', phoneticUK: '/hɪmˈself/',
    meaning: '他自己', example: 'He did it himself.', exampleTranslation: '他自己做的。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👦'
  },
  {
    id: 'history', word: 'history', phoneticUS: '/ˈhɪstəri/', phoneticUK: '/ˈhɪstəri/',
    meaning: '历史', example: 'Chinese history.', exampleTranslation: '中国历史。',
    category: 'school', difficulty: 'easy', grade: '8', level: 'middle', image: '📜'
  },
  {
    id: 'hit', word: 'hit', phoneticUS: '/hɪt/', phoneticUK: '/hɪt/',
    meaning: '打；撞击', example: 'Hit the ball.', exampleTranslation: '打球。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '⚾'
  },
  {
    id: 'hobby', word: 'hobby', phoneticUS: '/ˈhɑbi/', phoneticUK: '/ˈhɒbi/',
    meaning: '爱好', example: 'Reading is my hobby.', exampleTranslation: '读书是我的爱好。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🎨'
  },
  {
    id: 'hold', word: 'hold', phoneticUS: '/hoʊld/', phoneticUK: '/həʊld/',
    meaning: '握住；举行', example: 'Hold my hand.', exampleTranslation: '握住我的手。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🤝'
  },
  {
    id: 'hole', word: 'hole', phoneticUS: '/hoʊl/', phoneticUK: '/həʊl/',
    meaning: '洞', example: 'A big hole.', exampleTranslation: '一个大洞。',
    category: 'nature', difficulty: 'easy', grade: '8', level: 'middle', image: '🕳️'
  },
  {
    id: 'holiday', word: 'holiday', phoneticUS: '/ˈhɑlədeɪ/', phoneticUK: '/ˈhɒlədeɪ/',
    meaning: '假日', example: 'Summer holiday.', exampleTranslation: '暑假。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '🏖️'
  },
  {
    id: 'home', word: 'home', phoneticUS: '/hoʊm/', phoneticUK: '/həʊm/',
    meaning: '家', example: 'Go home.', exampleTranslation: '回家。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏠'
  },
  {
    id: 'homework', word: 'homework', phoneticUS: '/ˈhoʊmwɜrk/', phoneticUK: '/ˈhəʊmwɜk/',
    meaning: '家庭作业', example: 'Do your homework.', exampleTranslation: '做作业。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📝'
  },
  {
    id: 'honest', word: 'honest', phoneticUS: '/ˈɑnɪst/', phoneticUK: '/ˈɒnɪst/',
    meaning: '诚实的', example: 'Be honest.', exampleTranslation: '要诚实。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'honesty', word: 'honesty', phoneticUS: '/ˈɑnɪsti/', phoneticUK: '/ˈɒnɪsti/',
    meaning: '诚实', example: 'Honesty is important.', exampleTranslation: '诚实很重要。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'honor', word: 'honor', phoneticUS: '/ˈɑnər/', phoneticUK: '/ˈɒnə/',
    meaning: '荣誉', example: 'Win honor.', exampleTranslation: '赢得荣誉。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '🏆'
  },
  {
    id: 'hope', word: 'hope', phoneticUS: '/hoʊp/', phoneticUK: '/həʊp/',
    meaning: '希望', example: 'I hope so.', exampleTranslation: '我希望如此。',
    category: 'emotions', difficulty: 'easy', grade: '8', level: 'middle', image: '🙏'
  },
  {
    id: 'hopeful', word: 'hopeful', phoneticUS: '/ˈhoʊpfəl/', phoneticUK: '/ˈhəʊpfəl/',
    meaning: '有希望的', example: 'Be hopeful.', exampleTranslation: '要有希望。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '🌟'
  },
  {
    id: 'horse', word: 'horse', phoneticUS: '/hɔrs/', phoneticUK: '/hɔs/',
    meaning: '马', example: 'Ride a horse.', exampleTranslation: '骑马。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐴'
  },
  {
    id: 'hospital', word: 'hospital', phoneticUS: '/ˈhɑspɪtl/', phoneticUK: '/ˈhɒspɪtl/',
    meaning: '医院', example: 'Go to hospital.', exampleTranslation: '去医院。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏥'
  },
  {
    id: 'hot', word: 'hot', phoneticUS: '/hɑt/', phoneticUK: '/hɒt/',
    meaning: '热的', example: 'Hot weather.', exampleTranslation: '炎热的天气。',
    category: 'weather', difficulty: 'easy', grade: '7', level: 'middle', image: '🌡️'
  },
  {
    id: 'hotel', word: 'hotel', phoneticUS: '/hoʊˈtel/', phoneticUK: '/həʊˈtel/',
    meaning: '旅馆', example: 'Stay at a hotel.', exampleTranslation: '住旅馆。',
    category: 'places', difficulty: 'easy', grade: '8', level: 'middle', image: '🏨'
  },
  {
    id: 'hour', word: 'hour', phoneticUS: '/aʊər/', phoneticUK: '/aʊə/',
    meaning: '小时', example: 'One hour.', exampleTranslation: '一小时。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'house', word: 'house', phoneticUS: '/haʊs/', phoneticUK: '/haʊs/',
    meaning: '房子', example: 'My house.', exampleTranslation: '我的房子。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏠'
  },
  {
    id: 'housework', word: 'housework', phoneticUS: '/ˈhaʊswɜrk/', phoneticUK: '/ˈhaʊswɜk/',
    meaning: '家务', example: 'Do housework.', exampleTranslation: '做家务。',
    category: 'daily_life', difficulty: 'medium', grade: '8', level: 'middle', image: '🧹'
  },
  {
    id: 'how', word: 'how', phoneticUS: '/haʊ/', phoneticUK: '/haʊ/',
    meaning: '如何', example: 'How are you?', exampleTranslation: '你好吗？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'however', word: 'however', phoneticUS: '/haʊˈevər/', phoneticUK: '/haʊˈevə/',
    meaning: '然而', example: 'However, I cannot.', exampleTranslation: '然而，我不能。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🤔'
  },
  {
    id: 'huge', word: 'huge', phoneticUS: '/hjuːdʒ/', phoneticUK: '/hjuːdʒ/',
    meaning: '巨大的', example: 'A huge tree.', exampleTranslation: '巨大的树。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🌲'
  },
  {
    id: 'human', word: 'human', phoneticUS: '/ˈhjuːmən/', phoneticUK: '/ˈhjuːmən/',
    meaning: '人类', example: 'Human beings.', exampleTranslation: '人类。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'hundred', word: 'hundred', phoneticUS: '/ˈhʌndrəd/', phoneticUK: '/ˈhʌndrəd/',
    meaning: '百', example: 'One hundred.', exampleTranslation: '一百。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '💯'
  },
  {
    id: 'hunger', word: 'hunger', phoneticUS: '/ˈhʌŋɡər/', phoneticUK: '/ˈhʌŋɡə/',
    meaning: '饥饿', example: 'Hunger problem.', exampleTranslation: '饥饿问题。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🍽️'
  },
  {
    id: 'hungry', word: 'hungry', phoneticUS: '/ˈhʌŋɡri/', phoneticUK: '/ˈhʌŋɡri/',
    meaning: '饥饿的', example: 'I am hungry.', exampleTranslation: '我饿了。',
    category: 'emotions', difficulty: 'easy', grade: '7', level: 'middle', image: '😋'
  },
  {
    id: 'hunt', word: 'hunt', phoneticUS: '/hʌnt/', phoneticUK: '/hʌnt/',
    meaning: '打猎', example: 'Hunt animals.', exampleTranslation: '猎捕动物。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🏹'
  },
  {
    id: 'hurry', word: 'hurry', phoneticUS: '/ˈhɜri/', phoneticUK: '/ˈhʌri/',
    meaning: '匆忙', example: 'Hurry up!', exampleTranslation: '快点！',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🏃'
  },
  {
    id: 'hurt', word: 'hurt', phoneticUS: '/hɜrt/', phoneticUK: '/hɜt/',
    meaning: '受伤', example: 'Do not hurt.', exampleTranslation: '不要受伤。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🤕'
  },
  {
    id: 'husband', word: 'husband', phoneticUS: '/ˈhʌzbənd/', phoneticUK: '/ˈhʌzbənd/',
    meaning: '丈夫', example: 'Her husband.', exampleTranslation: '她的丈夫。',
    category: 'family', difficulty: 'easy', grade: '8', level: 'middle', image: '👨'
  },

  // I 部分词汇
  {
    id: 'ice', word: 'ice', phoneticUS: '/aɪs/', phoneticUK: '/aɪs/',
    meaning: '冰', example: 'Ice cream.', exampleTranslation: '冰淇淋。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍦'
  },
  {
    id: 'idea', word: 'idea', phoneticUS: '/aɪˈdiːə/', phoneticUK: '/aɪˈdɪə/',
    meaning: '主意', example: 'Good idea!', exampleTranslation: '好主意！',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💡'
  },
  {
    id: 'if', word: 'if', phoneticUS: '/ɪf/', phoneticUK: '/ɪf/',
    meaning: '如果', example: 'If I can.', exampleTranslation: '如果我能。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🤔'
  },
  {
    id: 'ill', word: 'ill', phoneticUS: '/ɪl/', phoneticUK: '/ɪl/',
    meaning: '生病的', example: 'I am ill.', exampleTranslation: '我病了。',
    category: 'body', difficulty: 'easy', grade: '7', level: 'middle', image: '🤒'
  },
  {
    id: 'illness', word: 'illness', phoneticUS: '/ˈɪlnɪs/', phoneticUK: '/ˈɪlnɪs/',
    meaning: '疾病', example: 'Serious illness.', exampleTranslation: '严重的疾病。',
    category: 'body', difficulty: 'medium', grade: '9', level: 'middle', image: '🏥'
  },
  {
    id: 'imagine', word: 'imagine', phoneticUS: '/ɪˈmædʒɪn/', phoneticUK: '/ɪˈmædʒɪn/',
    meaning: '想象', example: 'Imagine the future.', exampleTranslation: '想象未来。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '💭'
  },
  {
    id: 'important', word: 'important', phoneticUS: '/ɪmˈpɔrtənt/', phoneticUK: '/ɪmˈpɔtənt/',
    meaning: '重要的', example: 'Important things.', exampleTranslation: '重要的事。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '⭐'
  },
  {
    id: 'impossible', word: 'impossible', phoneticUS: '/ɪmˈpɑsəbl/', phoneticUK: '/ɪmˈpɒsəbl/',
    meaning: '不可能的', example: 'Nothing is impossible.', exampleTranslation: '没什么不可能。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '❌'
  },
  {
    id: 'improve', word: 'improve', phoneticUS: '/ɪmˈpruːv/', phoneticUK: '/ɪmˈpruːv/',
    meaning: '改进', example: 'Improve yourself.', exampleTranslation: '提升自己。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '📈'
  },
  {
    id: 'in', word: 'in', phoneticUS: '/ɪn/', phoneticUK: '/ɪn/',
    meaning: '在...里面', example: 'In the room.', exampleTranslation: '在房间里。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏠'
  },
  {
    id: 'inch', word: 'inch', phoneticUS: '/ɪntʃ/', phoneticUK: '/ɪntʃ/',
    meaning: '英寸', example: 'One inch.', exampleTranslation: '一英寸。',
    category: 'numbers', difficulty: 'medium', grade: '9', level: 'middle', image: '📏'
  },
  {
    id: 'include', word: 'include', phoneticUS: '/ɪnˈkluːd/', phoneticUK: '/ɪnˈkluːd/',
    meaning: '包括', example: 'Include everything.', exampleTranslation: '包括一切。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '➕'
  },
  {
    id: 'increase', word: 'increase', phoneticUS: '/ɪnˈkriːs/', phoneticUK: '/ɪnˈkriːs/',
    meaning: '增加', example: 'Increase your score.', exampleTranslation: '提高分数。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '📈'
  },
  {
    id: 'indeed', word: 'indeed', phoneticUS: '/ɪnˈdiːd/', phoneticUK: '/ɪnˈdiːd/',
    meaning: '确实', example: 'Indeed, it is true.', exampleTranslation: '确实如此。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '✅'
  },
  {
    id: 'information', word: 'information', phoneticUS: '/ˌɪnfərˈmeɪʃn/', phoneticUK: '/ˌɪnfəˈmeɪʃn/',
    meaning: '信息', example: 'Useful information.', exampleTranslation: '有用的信息。',
    category: 'technology', difficulty: 'medium', grade: '8', level: 'middle', image: 'ℹ️'
  },
  {
    id: 'inside', word: 'inside', phoneticUS: '/ɪnˈsaɪd/', phoneticUK: '/ɪnˈsaɪd/',
    meaning: '在...里面', example: 'Inside the box.', exampleTranslation: '在盒子里。',
    category: 'directions', difficulty: 'easy', grade: '8', level: 'middle', image: '📦'
  },
  {
    id: 'insist', word: 'insist', phoneticUS: '/ɪnˈsɪst/', phoneticUK: '/ɪnˈsɪst/',
    meaning: '坚持', example: 'Insist on doing it.', exampleTranslation: '坚持做这件事。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '💪'
  },
  {
    id: 'instead', word: 'instead', phoneticUS: '/ɪnˈsted/', phoneticUK: '/ɪnˈsted/',
    meaning: '代替', example: 'Do this instead.', exampleTranslation: '做这个代替。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🔄'
  },
  {
    id: 'instruction', word: 'instruction', phoneticUS: '/ɪnˈstrʌkʃn/', phoneticUK: '/ɪnˈstrʌkʃn/',
    meaning: '指示；说明', example: 'Follow the instructions.', exampleTranslation: '遵循说明。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📋'
  },
  {
    id: 'interest', word: 'interest', phoneticUS: '/ˈɪntrɪst/', phoneticUK: '/ˈɪntrɪst/',
    meaning: '兴趣', example: 'Have interest in music.', exampleTranslation: '对音乐感兴趣。',
    category: 'emotions', difficulty: 'medium', grade: '8', level: 'middle', image: '🎵'
  },
  {
    id: 'interesting', word: 'interesting', phoneticUS: '/ˈɪntrəstɪŋ/', phoneticUK: '/ˈɪntrəstɪŋ/',
    meaning: '有趣的', example: 'This is interesting.', exampleTranslation: '这很有趣。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '😄'
  },
  {
    id: 'international', word: 'international', phoneticUS: '/ˌɪntərˈnæʃnəl/', phoneticUK: '/ˌɪntəˈnæʃnəl/',
    meaning: '国际的', example: 'International school.', exampleTranslation: '国际学校。',
    category: 'society', difficulty: 'hard', grade: '9', level: 'middle', image: '🌍'
  },
  {
    id: 'internet', word: 'internet', phoneticUS: '/ˈɪntərnet/', phoneticUK: '/ˈɪntənet/',
    meaning: '互联网', example: 'Use the internet.', exampleTranslation: '使用互联网。',
    category: 'technology', difficulty: 'easy', grade: '8', level: 'middle', image: '🌐'
  },
  {
    id: 'interview', word: 'interview', phoneticUS: '/ˈɪntərvjuː/', phoneticUK: '/ˈɪntəvjuː/',
    meaning: '面试；采访', example: 'Job interview.', exampleTranslation: '工作面试。',
    category: 'jobs', difficulty: 'hard', grade: '9', level: 'middle', image: '💼'
  },
  {
    id: 'into', word: 'into', phoneticUS: '/ˈɪntuː/', phoneticUK: '/ˈɪntuː/',
    meaning: '进入', example: 'Go into the room.', exampleTranslation: '进入房间。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'introduce', word: 'introduce', phoneticUS: '/ˌɪntrəˈduːs/', phoneticUK: '/ˌɪntrəˈdjuːs/',
    meaning: '介绍', example: 'Introduce yourself.', exampleTranslation: '介绍你自己。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '👋'
  },
  {
    id: 'invent', word: 'invent', phoneticUS: '/ɪnˈvent/', phoneticUK: '/ɪnˈvent/',
    meaning: '发明', example: 'Invent new things.', exampleTranslation: '发明新事物。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '💡'
  },
  {
    id: 'invitation', word: 'invitation', phoneticUS: '/ˌɪnvɪˈteɪʃn/', phoneticUK: '/ˌɪnvɪˈteɪʃn/',
    meaning: '邀请', example: 'Accept the invitation.', exampleTranslation: '接受邀请。',
    category: 'daily_life', difficulty: 'medium', grade: '9', level: 'middle', image: '💌'
  },
  {
    id: 'invite', word: 'invite', phoneticUS: '/ɪnˈvaɪt/', phoneticUK: '/ɪnˈvaɪt/',
    meaning: '邀请', example: 'Invite friends.', exampleTranslation: '邀请朋友。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '💌'
  },
  {
    id: 'iron', word: 'iron', phoneticUS: '/ˈaɪərn/', phoneticUK: '/ˈaɪən/',
    meaning: '铁', example: 'Iron is hard.', exampleTranslation: '铁很硬。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🔩'
  },
  {
    id: 'island', word: 'island', phoneticUS: '/ˈaɪlənd/', phoneticUK: '/ˈaɪlənd/',
    meaning: '岛', example: 'A small island.', exampleTranslation: '一个小岛。',
    category: 'places', difficulty: 'medium', grade: '8', level: 'middle', image: '🏝️'
  },
  {
    id: 'it', word: 'it', phoneticUS: '/ɪt/', phoneticUK: '/ɪt/',
    meaning: '它', example: 'It is a cat.', exampleTranslation: '它是猫。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🐱'
  },
  {
    id: 'its', word: 'its', phoneticUS: '/ɪts/', phoneticUK: '/ɪts/',
    meaning: '它的', example: 'Its color.', exampleTranslation: '它的颜色。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🎨'
  },
  {
    id: 'itself', word: 'itself', phoneticUS: '/ɪtˈself/', phoneticUK: '/ɪtˈself/',
    meaning: '它自己', example: 'By itself.', exampleTranslation: '它自己。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '⚙️'
  },

  // J-L 部分词汇
  {
    id: 'jacket', word: 'jacket', phoneticUS: '/ˈdʒækɪt/', phoneticUK: '/ˈdʒækɪt/',
    meaning: '夹克', example: 'Wear a jacket.', exampleTranslation: '穿夹克。',
    category: 'clothes', difficulty: 'easy', grade: '7', level: 'middle', image: '🧥'
  },
  {
    id: 'January', word: 'January', phoneticUS: '/ˈdʒænjueri/', phoneticUK: '/ˈdʒænjuəri/',
    meaning: '一月', example: 'January is cold.', exampleTranslation: '一月很冷。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '📅'
  },
  {
    id: 'job', word: 'job', phoneticUS: '/dʒɑb/', phoneticUK: '/dʒɒb/',
    meaning: '工作', example: 'Find a job.', exampleTranslation: '找工作。',
    category: 'jobs', difficulty: 'easy', grade: '7', level: 'middle', image: '💼'
  },
  {
    id: 'join', word: 'join', phoneticUS: '/dʒɔɪn/', phoneticUK: '/dʒɔɪn/',
    meaning: '加入', example: 'Join the club.', exampleTranslation: '加入俱乐部。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🎯'
  },
  {
    id: 'joke', word: 'joke', phoneticUS: '/dʒoʊk/', phoneticUK: '/dʒəʊk/',
    meaning: '玩笑', example: 'Tell a joke.', exampleTranslation: '讲个笑话。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '😄'
  },
  {
    id: 'journey', word: 'journey', phoneticUS: '/ˈdʒɜrni/', phoneticUK: '/ˈdʒɜni/',
    meaning: '旅程', example: 'A long journey.', exampleTranslation: '漫长的旅程。',
    category: 'travel', difficulty: 'medium', grade: '9', level: 'middle', image: '🛤️'
  },
  {
    id: 'joy', word: 'joy', phoneticUS: '/dʒɔɪ/', phoneticUK: '/dʒɔɪ/',
    meaning: '快乐', example: 'Full of joy.', exampleTranslation: '充满快乐。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'judge', word: 'judge', phoneticUS: '/dʒʌdʒ/', phoneticUK: '/dʒʌdʒ/',
    meaning: '判断；法官', example: 'Judge fairly.', exampleTranslation: '公平判断。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '⚖️'
  },
  {
    id: 'juice', word: 'juice', phoneticUS: '/dʒuːs/', phoneticUK: '/dʒuːs/',
    meaning: '果汁', example: 'Orange juice.', exampleTranslation: '橙汁。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🧃'
  },
  {
    id: 'July', word: 'July', phoneticUS: '/dʒuˈlaɪ/', phoneticUK: '/dʒuːˈlaɪ/',
    meaning: '七月', example: 'July is hot.', exampleTranslation: '七月很热。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '☀️'
  },
  {
    id: 'jump', word: 'jump', phoneticUS: '/dʒʌmp/', phoneticUK: '/dʒʌmp/',
    meaning: '跳', example: 'Jump high.', exampleTranslation: '跳得高。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🦘'
  },
  {
    id: 'June', word: 'June', phoneticUS: '/dʒuːn/', phoneticUK: '/dʒuːn/',
    meaning: '六月', example: 'June is warm.', exampleTranslation: '六月很暖和。',
    category: 'months', difficulty: 'easy', grade: '7', level: 'middle', image: '🌤️'
  },
  {
    id: 'just', word: 'just', phoneticUS: '/dʒʌst/', phoneticUK: '/dʒʌst/',
    meaning: '只是；刚刚', example: 'Just a moment.', exampleTranslation: '等一下。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '⏰'
  },
  {
    id: 'keep', word: 'keep', phoneticUS: '/kiːp/', phoneticUK: '/kiːp/',
    meaning: '保持', example: 'Keep quiet.', exampleTranslation: '保持安静。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🤫'
  },
  {
    id: 'key', word: 'key', phoneticUS: '/kiː/', phoneticUK: '/kiː/',
    meaning: '钥匙；关键', example: 'The key to success.', exampleTranslation: '成功的关键。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '🔑'
  },
  {
    id: 'keyboard', word: 'keyboard', phoneticUS: '/ˈkiːbɔrd/', phoneticUK: '/ˈkiːbɔd/',
    meaning: '键盘', example: 'Use the keyboard.', exampleTranslation: '使用键盘。',
    category: 'technology', difficulty: 'easy', grade: '8', level: 'middle', image: '⌨️'
  },
  {
    id: 'kick', word: 'kick', phoneticUS: '/kɪk/', phoneticUK: '/kɪk/',
    meaning: '踢', example: 'Kick the ball.', exampleTranslation: '踢球。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '⚽'
  },
  {
    id: 'kid', word: 'kid', phoneticUS: '/kɪd/', phoneticUK: '/kɪd/',
    meaning: '小孩', example: 'A cute kid.', exampleTranslation: '可爱的孩子。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👧'
  },
  {
    id: 'kill', word: 'kill', phoneticUS: '/kɪl/', phoneticUK: '/kɪl/',
    meaning: '杀死', example: 'Do not kill.', exampleTranslation: '不要杀生。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🚫'
  },
  {
    id: 'kilo', word: 'kilo', phoneticUS: '/ˈkiːloʊ/', phoneticUK: '/ˈkiːləʊ/',
    meaning: '千克', example: 'One kilo.', exampleTranslation: '一公斤。',
    category: 'numbers', difficulty: 'medium', grade: '8', level: 'middle', image: '⚖️'
  },
  {
    id: 'kilometer', word: 'kilometer', phoneticUS: '/kɪˈlɑmɪtər/', phoneticUK: '/kɪˈlɒmɪtə/',
    meaning: '千米', example: 'Five kilometers.', exampleTranslation: '五千米。',
    category: 'numbers', difficulty: 'medium', grade: '8', level: 'middle', image: '📏'
  },
  {
    id: 'kind', word: 'kind', phoneticUS: '/kaɪnd/', phoneticUK: '/kaɪnd/',
    meaning: '善良的；种类', example: 'Be kind.', exampleTranslation: '要善良。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❤️'
  },
  {
    id: 'king', word: 'king', phoneticUS: '/kɪŋ/', phoneticUK: '/kɪŋ/',
    meaning: '国王', example: 'The lion is the king.', exampleTranslation: '狮子是国王。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👑'
  },
  {
    id: 'kiss', word: 'kiss', phoneticUS: '/kɪs/', phoneticUK: '/kɪs/',
    meaning: '吻', example: 'Kiss the baby.', exampleTranslation: '亲吻宝宝。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '💋'
  },
  {
    id: 'kitchen', word: 'kitchen', phoneticUS: '/ˈkɪtʃɪn/', phoneticUK: '/ˈkɪtʃɪn/',
    meaning: '厨房', example: 'Cook in the kitchen.', exampleTranslation: '在厨房做饭。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🍳'
  },
  {
    id: 'kite', word: 'kite', phoneticUS: '/kaɪt/', phoneticUK: '/kaɪt/',
    meaning: '风筝', example: 'Fly a kite.', exampleTranslation: '放风筝。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '🪁'
  },
  {
    id: 'knee', word: 'knee', phoneticUS: '/niː/', phoneticUK: '/niː/',
    meaning: '膝盖', example: 'Bend your knees.', exampleTranslation: '弯曲膝盖。',
    category: 'body', difficulty: 'easy', grade: '8', level: 'middle', image: '🦵'
  },
  {
    id: 'knife', word: 'knife', phoneticUS: '/naɪf/', phoneticUK: '/naɪf/',
    meaning: '刀', example: 'Use a knife.', exampleTranslation: '用刀。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🔪'
  },
  {
    id: 'knock', word: 'knock', phoneticUS: '/nɑk/', phoneticUK: '/nɒk/',
    meaning: '敲', example: 'Knock on the door.', exampleTranslation: '敲门。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🚪'
  },
  {
    id: 'know', word: 'know', phoneticUS: '/noʊ/', phoneticUK: '/nəʊ/',
    meaning: '知道', example: 'I know.', exampleTranslation: '我知道。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🧠'
  },
  {
    id: 'knowledge', word: 'knowledge', phoneticUS: '/ˈnɑlɪdʒ/', phoneticUK: '/ˈnɒlɪdʒ/',
    meaning: '知识', example: 'Gain knowledge.', exampleTranslation: '获取知识。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📚'
  },
];

export default vocabularyHM;